import type { Post } from "@/types/content";

export const postsPart2: Post[] = [
  {
    id: "post-6",
    slug: "taipei-nail-salon-top8",
    title: "台北美甲推薦 TOP 8｜從日系到韓系最精緻的美甲工作室",
    excerpt: "台北美甲店密度超高，但找到技術穩定又不刮傷甲面的店家不容易。神秘客實測 20 間，精選 8 間做工精緻、不廢話的美甲好店。",
    coverImage: "https://readdy.ai/api/search-image?query=Beautiful%20nail%20art%20studio%20with%20colorful%20nail%20polish%20bottles%20and%20professional%20nail%20technician%20working%20on%20elegant%20nail%20design%20warm%20lighting%20simple%20clean%20background%20photography&width=1200&height=630&seq=106&orientation=landscape",
    category: "美甲",
    tags: ["台北", "美甲", "日系美甲", "韓系美甲", "美甲工作室", "懶人包", "推薦"],
    author: {
      id: "author-3",
      name: "神秘客A",
      avatar: "https://readdy.ai/api/search-image?query=Asian%20woman%20with%20glasses%20portrait%20professional%20clean%20white%20background%20headshot&width=100&height=100&seq=203&orientation=squarish",
      bio: "資深美業神秘客，專精美容保養與外貌美化類評測，涵蓋美甲、美睫、霧眉、采耳、除毛與做臉等項目。擁有 5 年神秘客資歷，累積評測店家超過 120 間。善於從細節觀察服務品質，特別關注衛生標準與長期效果。堅持匿名探訪，幫助消費者找到最適合自己的美業選擇。",
    },
    publishedAt: "2025-04-20",
    readingTime: 9,
    rating: 4.6,
    reviewCount: 134,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>台北的美甲工作室從幾百元的學生指甲到幾千元的手工藝術設計都有，風格也從日系清透到韓系光療、立體飾品應有盡有。但美甲的地雷不少——甲面有氣泡、顏色色差大、刮傷指緣皮膚、或是光療不扎實容易翹起。</p><p>神秘客這次實測了台北 20 間美甲工作室，評分標準包含：做工細膩度、持久度（2 週後狀態）、師傅溝通能力、衛生標準。</p>",
      },
      {
        _type: "shopReview",
        _key: "reviews",
        title: "TOP 8 美甲工作室評比",
        shops: [
          {
            _key: "s1",
            name: "SAKURA 日式美甲",
            rating: 4.9,
            priceRange: "$800 - $2,500",
            address: "台北市中山區中山北路二段 120 號 3F",
            tags: ["日系美甲", "光療", "手繪藝術"],
            pros: ["手繪細節精緻到位，不像其他家貼紙敷衍", "光療扎實，2 週後幾乎無翹邊", "師傅會先做設計溝通，不擅自決定"],
            cons: ["需提前 1 週以上預約", "部分手繪設計需加收費用"],
            recommendation: "想要有設計感、品質又穩定的日系美甲首選。手繪服務很有誠意，等候時間值得。",
            image: "https://readdy.ai/api/search-image?query=Japanese%20style%20nail%20art%20studio%20with%20delicate%20floral%20nail%20designs%20and%20professional%20workstation%20warm%20lighting%20elegant%20simple%20background%20photography&width=600&height=400&seq=321&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=SAKURA+日式美甲+台北+中山區",
          },
          {
            _key: "s2",
            name: "MONO 韓系美甲",
            rating: 4.7,
            priceRange: "$600 - $1,800",
            address: "台北市大安區忠孝東路四段 310 號 4F",
            tags: ["韓系美甲", "鏡面光療", "大理石紋"],
            pros: ["韓系大理石紋和鏡面光療做得相當到位", "師傅效率很高，預約時間準確", "價格平實，完成度很高"],
            cons: ["店內空間偏小，等候較不舒適", "複雜設計需另加費"],
            recommendation: "追求韓系簡約風美甲的首選。鏡面光療做完超閃，拍照一定好看。",
            image: "https://readdy.ai/api/search-image?query=Korean%20minimalist%20nail%20salon%20with%20chrome%20mirror%20nail%20designs%20and%20modern%20interior%20clean%20white%20background%20photography&width=600&height=400&seq=322&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=MONO+韓系美甲+台北+大安區",
          },
        ],
      },
      {
        _type: "faq",
        _key: "faq",
        title: "美甲常見問題",
        items: [
          { _key: "q1", question: "光療和一般指甲油有什麼差別？", answer: "光療（凝膠）用紫外線燈固化，持久度是一般指甲油的 3-4 倍，通常可維持 3-4 週不翹邊。一般指甲油 3-5 天就容易剝落。" },
          { _key: "q2", question: "美甲多久換一次比較好？", answer: "光療建議 3-4 週換一次，配合指甲生長速度。指甲根部有明顯空隙就要去補或換新。" },
          { _key: "q3", question: "自己卸光療可以嗎？", answer: "建議回店讓師傅卸，強行剝除光療會傷害甲面。如果真的要自己卸，需要錫箔紙包覆 + 去光水泡軟後輕輕推除。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多美甲評比",
        subtitle: "神秘客實測台北美甲工作室，公正評比做工品質與持久度",
        buttonLabel: "查看美甲評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台北美甲推薦 TOP 8｜日系韓系美甲工作室評比",
      description: "台北美甲評比！神秘客實測 20 間美甲工作室，精選 8 間做工精緻、持久度高的美甲好店。",
      keywords: ["台北美甲", "美甲推薦", "日系美甲", "韓系美甲", "光療美甲"],
    },
  },
  {
    id: "post-7",
    slug: "taipei-lash-extension-top6",
    title: "台北美睫推薦 TOP 6｜睫毛嫁接、貼片一次全評比",
    excerpt: "美睫技術差異大，一不小心就踩雷——睫毛參差、黏著不牢、甚至傷及真睫毛。神秘客走訪台北 18 間美睫工作室，為你找出最安全又自然的 6 間。",
    coverImage: "https://readdy.ai/api/search-image?query=Professional%20eyelash%20extension%20studio%20with%20magnifying%20lamp%20and%20beauty%20tools%20client%20relaxing%20in%20comfortable%20chair%20warm%20soft%20lighting%20clean%20simple%20background%20photography&width=1200&height=630&seq=107&orientation=landscape",
    category: "美睫",
    tags: ["台北", "美睫", "睫毛嫁接", "睫毛貼片", "懶人包", "推薦"],
    author: {
      id: "author-3",
      name: "神秘客A",
      avatar: "https://readdy.ai/api/search-image?query=Asian%20woman%20with%20glasses%20portrait%20professional%20clean%20white%20background%20headshot&width=100&height=100&seq=203&orientation=squarish",
      bio: "資深美業神秘客，專精美容保養與外貌美化類評測，涵蓋美甲、美睫、霧眉、采耳、除毛與做臉等項目。擁有 5 年神秘客資歷，累積評測店家超過 120 間。善於從細節觀察服務品質，特別關注衛生標準與長期效果。堅持匿名探訪，幫助消費者找到最適合自己的美業選擇。",
    },
    publishedAt: "2025-04-25",
    readingTime: 9,
    rating: 4.7,
    reviewCount: 156,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>美睫是個技術門檻相對高的美業項目——嫁接位置、單根還是扇形、膠水品質、師傅的眼力與手穩定度，任何環節出問題都會讓結果看起來假、不舒服甚至傷到真睫毛。</p><p>神秘客走訪台北 18 間美睫工作室，以<strong>自然度、持久度（2 週後狀態）、過敏反應、師傅溝通</strong>四個維度評比，找出最值得推薦的 6 間。</p>",
      },
      {
        _type: "featureList",
        _key: "types",
        title: "美睫類型說明",
        features: [
          { _key: "t1", icon: "ri-eye-line", title: "單根嫁接（Classical）", description: "1:1 嫁接，最自然。適合睫毛本來就不稀少，只需加濃加長者。效果維持 4-6 週" },
          { _key: "t2", icon: "ri-eye-2-line", title: "扇形嫁接（Volume）", description: "1:2-1:6 嫁接，蓬鬆濃密。適合睫毛稀少想要顯著濃密感。效果維持 3-4 週" },
          { _key: "t3", icon: "ri-sparkling-line", title: "混合嫁接（Hybrid）", description: "結合單根與扇形，自然中帶點層次感。近年最流行的選擇" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多美睫評比",
        subtitle: "神秘客實測台北美睫工作室，公正評比自然度與持久度",
        buttonLabel: "查看美睫評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台北美睫推薦 TOP 6｜睫毛嫁接評比 2025",
      description: "台北美睫評比！神秘客走訪 18 間，精選 6 間自然、持久、安全的美睫工作室。",
      keywords: ["台北美睫", "美睫推薦", "睫毛嫁接", "扇形睫毛"],
    },
  },
  {
    id: "post-8",
    slug: "taipei-eyebrow-embroidery-top5",
    title: "台北霧眉推薦 TOP 5｜神秘客評比最自然的韓式霧眉",
    excerpt: "霧眉一做就是 2-3 年，選錯師傅就要看 2-3 年的悲劇。神秘客走訪台北 15 間半永久紋繡工作室，為你找出手法最自然、設計最精準的 5 間。",
    coverImage: "https://readdy.ai/api/search-image?query=Taiwanese%20eyebrow%20microblading%20studio%20with%20a%20skilled%20Asian%20female%20artist%20with%20black%20hair%20carefully%20performing%20semi-permanent%20eyebrow%20tattoo%20on%20a%20young%20Asian%20Taiwanese%20woman%20client%20lying%20comfortably%20with%20eyes%20closed%2C%20clean%20white%20clinical%20beauty%20interior%20with%20soft%20warm%20lighting%2C%20professional%20tools%20and%20pigments%20visible%2C%20simple%20clean%20background%20photography%20with%20editorial%20quality%20and%20warm%20color%20tones&width=1200&height=630&seq=2004&orientation=landscape",
    category: "霧眉",
    tags: ["台北", "霧眉", "半永久紋繡", "韓式霧眉", "眉毛設計", "懶人包", "推薦"],
    author: {
      id: "author-3",
      name: "神秘客A",
      avatar: "https://readdy.ai/api/search-image?query=Asian%20woman%20with%20glasses%20portrait%20professional%20clean%20white%20background%20headshot&width=100&height=100&seq=203&orientation=squarish",
      bio: "資深美業神秘客，專精美容保養與外貌美化類評測，涵蓋美甲、美睫、霧眉、采耳、除毛與做臉等項目。擁有 5 年神秘客資歷，累積評測店家超過 120 間。善於從細節觀察服務品質，特別關注衛生標準與長期效果。堅持匿名探訪，幫助消費者找到最適合自己的美業選擇。",
    },
    publishedAt: "2025-04-18",
    readingTime: 9,
    rating: 4.8,
    reviewCount: 203,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>霧眉（霧感眉、粉霧眉）是近年最受歡迎的半永久紋繡項目，效果接近真實眉毛，相比舊式紋眉自然許多。但霧眉是半永久彩妝，做完 2-3 年才會完全代謝，如果師傅設計不佳或顏色不適合，就要帶著這雙眉毛生活很長一段時間。</p><p>神秘客這次走訪 15 間台北霧眉工作室，評比重點：<strong>事前臉型與眉形分析的認真度、操作時的溝通、色料安全性、完成後的自然度</strong>。</p>",
      },
      {
        _type: "featureList",
        _key: "guide",
        title: "霧眉選店必看重點",
        features: [
          { _key: "g1", icon: "ri-user-star-line", title: "設計溝通夠不夠詳細", description: "好的師傅會花 20-30 分鐘了解你的臉型、膚色、習慣妝感，而不是直接拿設計稿給你蓋章確認" },
          { _key: "g2", icon: "ri-palette-line", title: "色料成分是否透明", description: "要確認使用的色料是否符合食藥署規定，好的工作室會主動說明品牌與成分" },
          { _key: "g3", icon: "ri-image-line", title: "看真實作品，不只是修過圖的", description: "要求看原圖或未後製的作品，有些店家的成品濾鏡用太重，實際效果大相徑庭" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多霧眉評比",
        subtitle: "神秘客實測台北霧眉工作室，公正評比設計品質與自然度",
        buttonLabel: "查看霧眉評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台北霧眉推薦 TOP 5｜韓式霧眉工作室評比 2025",
      description: "台北霧眉評比！神秘客走訪 15 間，精選 5 間設計自然、色料安全的霧眉好店。附選店重點攻略。",
      keywords: ["台北霧眉", "霧眉推薦", "半永久紋繡", "韓式霧眉", "眉毛紋繡"],
    },
  },
  {
    id: "post-9",
    slug: "taipei-hair-removal-top6",
    title: "台北除毛推薦 TOP 6｜雷射 vs 蜜蠟 vs 脈衝光完整比較",
    excerpt: "除毛方式五花八門，效果與痛感差距極大。神秘客走訪台北 18 間除毛專門店，從雷射、蜜蠟到脈衝光全面評比，幫你找到最適合自己的除毛方案。",
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20hair%20removal%20clinic%20in%20Taipei%20with%20a%20professional%20Asian%20Taiwanese%20female%20therapist%20wearing%20white%20medical%20scrubs%20and%20face%20mask%20using%20advanced%20laser%20IPL%20device%20on%20a%20relaxed%20Asian%20female%20client%20lying%20on%20a%20treatment%20bed%2C%20clean%20white%20minimalist%20medical%20room%20with%20soft%20diffused%20lighting%2C%20professional%20beauty%20clinic%20aesthetic%2C%20simple%20clean%20background%20photography%20with%20high%20quality%20editorial%20style&width=1200&height=630&seq=2003&orientation=landscape",
    category: "除毛",
    tags: ["台北", "除毛", "雷射除毛", "蜜蠟除毛", "脈衝光", "懶人包", "推薦"],
    author: {
      id: "author-3",
      name: "神秘客A",
      avatar: "https://readdy.ai/api/search-image?query=Asian%20woman%20with%20glasses%20portrait%20professional%20clean%20white%20background%20headshot&width=100&height=100&seq=203&orientation=squarish",
      bio: "資深美業神秘客，專精美容保養與外貌美化類評測，涵蓋美甲、美睫、霧眉、采耳、除毛與做臉等項目。擁有 5 年神秘客資歷，累積評測店家超過 120 間。善於從細節觀察服務品質，特別關注衛生標準與長期效果。堅持匿名探訪，幫助消費者找到最適合自己的美業選擇。",
    },
    publishedAt: "2025-05-01",
    readingTime: 10,
    rating: 4.5,
    reviewCount: 178,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>除毛是台灣女性（以及越來越多男性）的重要美容需求，但方式很多、效果差異很大。搞清楚各種方法的原理，才能選到最適合自己的方案。</p>",
      },
      {
        _type: "featureList",
        _key: "compare",
        title: "三大除毛方式比較",
        features: [
          { _key: "c1", icon: "ri-fire-line", title: "雷射除毛（永久）", description: "利用雷射光破壞毛囊，效果永久。適合深色毛髮，多個療程後可達到 80-90% 的減毛效果。費用較高但長期最划算" },
          { _key: "c2", icon: "ri-sparkling-line", title: "脈衝光（IPL）", description: "廣譜光線照射，也能破壞毛囊。比雷射更溫和但效果稍弱。適合膚色較白、毛髮較深的人，通常需要 6-8 次療程" },
          { _key: "c3", icon: "ri-drop-line", title: "蜜蠟除毛（暫時）", description: "連根拔起，效果立即但僅維持 3-6 週。痛感較強但比刮毛生長速度慢，毛髮也會越來越細軟。費用低" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多除毛評比",
        subtitle: "神秘客實測台北除毛店家，公正評比安全性與效果",
        buttonLabel: "查看除毛評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台北除毛推薦 TOP 6｜雷射 vs 蜜蠟 vs 脈衝光完整比較",
      description: "台北除毛評比！三大除毛方式詳解，神秘客走訪 18 間，精選 6 間安全有效的除毛店家。",
      keywords: ["台北除毛", "雷射除毛", "蜜蠟除毛", "脈衝光除毛", "除毛推薦"],
    },
  },
  {
    id: "post-10",
    slug: "taipei-hair-salon-top8",
    title: "台北美髮推薦 TOP 8｜從染燙到剪髮最值得信賴的髮廊",
    excerpt: "找到一間技術穩定的髮廊難如登天。神秘客走訪台北 25 間髮廊，從剪髮技術、燙染品質到服務態度全面評比，精選出 8 間真正靠得住的美髮好店。",
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20upscale%20hair%20salon%20interior%20with%20professional%20styling%20chairs%20mirrors%20and%20good%20lighting%20stylists%20working%20with%20clients%20sophisticated%20atmosphere%20simple%20background%20photography&width=1200&height=630&seq=110&orientation=landscape",
    category: "美髮",
    tags: ["台北", "美髮", "髮廊", "染髮", "燙髮", "懶人包", "推薦"],
    author: {
      id: "author-2",
      name: "Chen 神秘客",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20man%20portrait%20confident%20smile%20clean%20white%20background%20professional%20headshot&width=100&height=100&seq=202&orientation=squarish",
      bio: "資深美業神秘客，專精美髮造型與頭皮護理類評測。走訪台灣超過 80 間美髮沙龍、頭皮護理中心與越式洗髮店，對於設計師技術、護理產品成分與頭皮檢測儀器有深入研究。堅持匿名探訪，給讀者最直白的消費建議。",
    },
    publishedAt: "2025-05-05",
    readingTime: 11,
    rating: 4.5,
    reviewCount: 143,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>台北的髮廊從 $200 的快剪到萬元的設計師剪髮都有，但「貴的不一定好，便宜的不一定差」這句話在美髮業最真實。選髮廊最重要的是找到跟你溝通頻率一致的設計師，一個懂你、願意聽你說話的設計師比任何技術都重要。</p><p>神秘客這次走訪台北 25 間髮廊，分為三個客單價帶評比，讓不同預算的你都能找到適合的選擇。</p>",
      },
      {
        _type: "featureList",
        _key: "tips",
        title: "選髮廊避雷指南",
        features: [
          { _key: "t1", icon: "ri-chat-1-line", title: "溝通是關鍵", description: "設計師如果上來就拿剪刀，沒有充分了解你想要的效果，就算技術很好也可能做出你不滿意的結果" },
          { _key: "t2", icon: "ri-image-line", title: "帶參考圖", description: "用文字描述很難精準，帶 2-3 張參考照片，同時說明你不想要哪種風格，能大幅減少誤解" },
          { _key: "t3", icon: "ri-time-line", title: "避開超忙的時段", description: "週末下午客流量最大，設計師狀態可能不佳。週間下午時段通常能獲得更多時間和注意力" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多美髮評比",
        subtitle: "神秘客實測台北髮廊，公正評比剪染燙技術與服務品質",
        buttonLabel: "查看美髮評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台北美髮推薦 TOP 8｜髮廊剪染燙全面評比 2025",
      description: "台北美髮評比！神秘客走訪 25 間髮廊，精選 8 間技術穩定、溝通良好的美髮好店。附選店攻略。",
      keywords: ["台北美髮", "美髮推薦", "台北髮廊", "染髮推薦", "燙髮推薦"],
    },
  },
];